<template>
    <section class="feed container-mobile">
        <div v-if="pageLoader" class="page-loader">
            {{ $t("loading.loading") }}
        </div>

        <div v-else>
            <p v-if="feedIsEmpty('objects')" class="no-content">
                {{ $t("feed.StoriesSectionYet") }}
            </p>
            <template v-for="(object, index) in feed">
                <feed-story
                    v-if="object.type === 'story'"
                    :ref="'element' + index"
                    :story="object.object"
                ></feed-story>
                <feed-photo
                    v-else-if="object.type === 'photo'"
                    :ref="'element' + index"
                    :photo="object.object"
                ></feed-photo>
                <feed-video
                    v-else-if="object.type === 'video'"
                    :ref="'element' + index"
                    :video="object.object"
                ></feed-video>
                <feed-user
                    v-else-if="object.type === 'user'"
                    :ref="'element' + index"
                    :feedUser="object.object"
                ></feed-user>
                <div
                    v-else-if="object.type === 'guestpuzzle'"
                    :ref="'element' + index"
                    class="info-item info-block info-item-body feed-guestpuzzle"
                >
                    <div
                        @click="
                            $modal.show('puzzle', {
                                image: object.object.image,
                            })
                        "
                        class="feed-image feed-puzzle"
                        :style="{
                            'background-image':
                                object.object && object.object.blurred
                                    ? 'url(' + object.object.blurred + ')'
                                    : '',
                        }"
                    >
                        <div class="button-yellow-gradient">
                            {{ $t("feed.tryPuzzle") }}
                        </div>
                    </div>
                </div>
                <YandexAd v-if="(index + 1) % 8 === 0" />
            </template>

            <div v-if="moreLoader" class="buttons-row">
                <button class="button-loader"></button>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { observeListEnd } from "@/mixins/observeListEnd";
import FeedStory from "@/components/Blocks/FeedStory";
import FeedPhoto from "@/components/Blocks/FeedPhoto";
import FeedVideo from "@/components/Blocks/FeedVideo";
import FeedUser from "@/components/Blocks/FeedUser";
import YandexAd from "@/components/Blocks/YandexAd.vue";

export default {
    name: "Feed",
    props: {
        i18n: Object,
    },
    components: {
        FeedStory,
        FeedPhoto,
        FeedVideo,
        FeedUser,
        YandexAd,
    },
    mixins: [observeListEnd],
    data() {
        return {
            pageLoader: true,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            isEmpty: "user/isEmpty",
            feed: "home/fetch",
            feedNext: "home/fetchNext",
            feedIsEmpty: "home/isEmpty",
            errors: "home/errors",
        }),
    },
    created() {
        this.getFeed();
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting === true) {
                    this.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    watch: {
        "user.id"() {
            this.getFeed();
        },
    },
    methods: {
        getFeed() {
            this.$store
                .dispatch("home/get")
                .then(() => {
                    this.pageLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        updateMoreIndex() {
            this.moreIndex = this.feed.length - 2;
        },
        showMore() {
            if (this.feedNext) {
                this.moreLoader = true;
                this.$store
                    .dispatch("home/getNext")
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_votes";
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_feed";
</style>
